// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container-v7 {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 99999999;
    pointer-events: none;
    animation: fadeInOut 3.5s ease-in-out forwards;
    max-width: 350px;
    width: 90%;
}

@keyframes fadeInOut {
    0% { opacity: 0; transform: translateX(100%); }
    10% { opacity: 1; transform: translateX(0); }
    90% { opacity: 1; transform: translateX(0); }
    100% { opacity: 0; transform: translateX(100%); }
}

.toast-box-v7 {
    display: flex;
    align-items: stretch;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    cursor: pointer;
    pointer-events: auto;
    transition: transform 0.2s;
    border: 1px solid #E0E0E0;
}

.toast-box-v7:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.toast-type-bar {
    width: 8px;
    flex-shrink: 0;
}

.toast-type-bar.success { background-color: #10B981; }
.toast-type-bar.danger { background-color: #EF4444; }
.toast-type-bar.warning { background-color: #FBBF24; }
.toast-type-bar.info { background-color: #3B82F6; }

.toast-content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    flex-grow: 1;
}

.toast-icon-message {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-grow: 1;
}

.toast-icon-v7 {
    padding-top: 2px;
    color: #333;
}

.toast-icon-v7.success { color: #10B981; } 
.toast-icon-v7.danger { color: #EF4444; } 
.toast-icon-v7.warning { color: #FBBF24; } 
.toast-icon-v7.info { color: #3B82F6; } 

.toast-title-v7 {
    font-weight: 700;
    color: #333;
    display: block;
    margin-bottom: 2px;
    font-size: 0.95rem;
}

.toast-message-text {
    color: #555;
    font-size: 0.85rem;
    margin: 0;
    line-height: 1.3;
}

.toast-close-btn-v7 {
    background: none;
    border: none;
    color: #AAA;
    cursor: pointer;
    margin-left: 10px;
    flex-shrink: 0;
    padding: 5px;
    border-radius: 4px;
    transition: color 0.2s, background-color 0.2s;
}

.toast-close-btn-v7:hover {
    color: #333;
    background-color: #F0F0F0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/alert/alert.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,8CAA8C;IAC9C,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,KAAK,UAAU,EAAE,2BAA2B,EAAE;IAC9C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,OAAO,UAAU,EAAE,2BAA2B,EAAE;AACpD;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA,0BAA0B,yBAAyB,EAAE;AACrD,yBAAyB,yBAAyB,EAAE;AACpD,0BAA0B,yBAAyB,EAAE;AACrD,uBAAuB,yBAAyB,EAAE;;AAElD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,yBAAyB,cAAc,EAAE;AACzC,wBAAwB,cAAc,EAAE;AACxC,yBAAyB,cAAc,EAAE;AACzC,sBAAsB,cAAc,EAAE;;AAEtC;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B","sourcesContent":[".toast-container-v7 {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 99999999;\n    pointer-events: none;\n    animation: fadeInOut 3.5s ease-in-out forwards;\n    max-width: 350px;\n    width: 90%;\n}\n\n@keyframes fadeInOut {\n    0% { opacity: 0; transform: translateX(100%); }\n    10% { opacity: 1; transform: translateX(0); }\n    90% { opacity: 1; transform: translateX(0); }\n    100% { opacity: 0; transform: translateX(100%); }\n}\n\n.toast-box-v7 {\n    display: flex;\n    align-items: stretch;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    cursor: pointer;\n    pointer-events: auto;\n    transition: transform 0.2s;\n    border: 1px solid #E0E0E0;\n}\n\n.toast-box-v7:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.toast-type-bar {\n    width: 8px;\n    flex-shrink: 0;\n}\n\n.toast-type-bar.success { background-color: #10B981; }\n.toast-type-bar.danger { background-color: #EF4444; }\n.toast-type-bar.warning { background-color: #FBBF24; }\n.toast-type-bar.info { background-color: #3B82F6; }\n\n.toast-content-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px;\n    flex-grow: 1;\n}\n\n.toast-icon-message {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    flex-grow: 1;\n}\n\n.toast-icon-v7 {\n    padding-top: 2px;\n    color: #333;\n}\n\n.toast-icon-v7.success { color: #10B981; } \n.toast-icon-v7.danger { color: #EF4444; } \n.toast-icon-v7.warning { color: #FBBF24; } \n.toast-icon-v7.info { color: #3B82F6; } \n\n.toast-title-v7 {\n    font-weight: 700;\n    color: #333;\n    display: block;\n    margin-bottom: 2px;\n    font-size: 0.95rem;\n}\n\n.toast-message-text {\n    color: #555;\n    font-size: 0.85rem;\n    margin: 0;\n    line-height: 1.3;\n}\n\n.toast-close-btn-v7 {\n    background: none;\n    border: none;\n    color: #AAA;\n    cursor: pointer;\n    margin-left: 10px;\n    flex-shrink: 0;\n    padding: 5px;\n    border-radius: 4px;\n    transition: color 0.2s, background-color 0.2s;\n}\n\n.toast-close-btn-v7:hover {\n    color: #333;\n    background-color: #F0F0F0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
